import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import QuantityCounter from '../common/QuantityCounter';

/**
 * Component that reprents items in the cart.
 * @param {Object} item cart item
 * @param {Function} removeItem function for removing an item from the cart
 * @param {Function} setItemQuantity function for setting the quantity of an
 * item in the cart
 * @return {Component}
 */
function CartItem({item, removeItem, setItemQuantity}) {
  const [quantity, setQuantity] = useState(item.quantity);
  // When quantity changes, update cart quantity
  useEffect(() => setItemQuantity(quantity), [quantity]);

  /**
   * Calls the removeItem prop function, passing in the product id.
   */
  function remove() {
    removeItem(item.product.id);
  }


  return (
    <div className="cart-item-container">
      <div className="cart-item-sub-box">
        <div className="cart-item-name-remove">
          <div className="cart-item-name">{item.product.title}</div>
          <div className="cart-item-remove"
            onClick={() => remove()}>Remove</div>
            {item.product.title.includes("RenderMan") &&
              <span className="cart-item-notice">Renderman UBL hours will be available for purchase until August 15, 2025. The Thinkbox UBL Marketplace is set to be deprecated on 30th of September 2025.</span>
            }
            {item.product.title.includes("V-Ray") &&
              <span className="cart-item-notice">V-Ray UBL hours will be available for purchase until August 15, 2025. The Thinkbox UBL Marketplace is set to be deprecated on 30th of September 2025. The UBL feature in Deadline 10 is now available via the new AWS Deadline Cloud UBL. For detailed instructions, please follow <a target="_blank" href="https://awsthinkbox.zendesk.com/hc/en-us/articles/22883209044759-AWS-Deadline-Cloud-UBL-for-Deadline-10-on-AWS">this link</a>.</span>
            }
        </div>
        <img className="cart-item-image"
          src={item.product.featuredImage.originalSrc}/>
      </div>
      <div className="cart-item-quantity">
        <QuantityCounter
          quantity={item.quantity}
          setQuantity={setQuantity} />
      </div>
      <div className="cart-item-total">
        ${Number(item.product.priceRangeV2.maxVariantPrice.amount * item.quantity).toFixed(2)}
      </div>
    </div>
  );
}

CartItem.propTypes = {
  item: PropTypes.object,
  removeItem: PropTypes.func,
  setItemQuantity: PropTypes.func,
};

export default CartItem;
